import { Text, type StyleProp, type ViewStyle } from "react-native";
import { colors } from "../theme/tokens";
import { IconButton } from "./IconButton";

/** The close's tap target is this square. */
export const CLOSE_BUTTON_SIZE = 28;

export type CloseButtonProps = {
  onPress: () => void;
  accessibilityLabel?: string;
  /** Stable analytics identifier, required when the label is translated. */
  action?: string;
  testID?: string;
  style?: StyleProp<ViewStyle>;
};

/**
 * The bare, dimmed ✕ that closes dialogs, sheets and full-screen reviews.
 * Dialog draws its own close with this, so every close in the app looks the
 * same (#3848: bare everywhere, no circle behind it).
 */
export function CloseButton({
  onPress,
  accessibilityLabel = "Close",
  action,
  testID,
  style,
}: CloseButtonProps) {
  return (
    <IconButton
      onPress={onPress}
      hitSlop={12}
      accessibilityLabel={accessibilityLabel}
      action={action}
      testID={testID}
      size={CLOSE_BUTTON_SIZE}
      pressedOpacity={1}
      style={style}
    >
      <Text style={{ fontSize: 18, color: colors.textFaint }}>✕</Text>
    </IconButton>
  );
}

export default CloseButton;
